import { InjectionToken } from '@angular/core';

export const ZOP_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>(
  'ZOP_MOCK_API_DEFAULT_DELAY'
);
